import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { menuPerm } from 'src/app/master/menuPerm.model';
import { Globle } from 'src/assets/globle';
import { Permission } from './permission.model';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {



  constructor(private http: HttpClient, private global: Globle, private localStorage: LocalStorageService) {


  }

  getRoles() {
    return this.http.get<[]>(this.global.APIURL + "identity/lstroles");
  }

  getAll(menuId: number, userId: any) {
    return this.http.get<Permission[]>(this.global.APIURL + "permission?menuId=" + menuId +
      "&userId=" + userId);
  }

  Create(menuPerm: any) {
    return this.http.post(this.global.APIURL + "permission", menuPerm)
  }

  getMenu(userId: string) {
    return this.http.get<menuPerm[]>(this.global.APIURL + "permission/getbyuser?userId=" + userId);
  }
}
